export default "__VITE_ASSET__BoymkGIj__"